import React from 'react';

interface CheckoutFormDisplay {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}

export const CheckoutFormDisplayContext = React.createContext<CheckoutFormDisplay>({
  isLoading: false,
  setLoading: (_) => {},
});

/**
 * Use to access the layout's loading state
 */
export function useCheckoutFormDisplay() {
  return React.useContext(CheckoutFormDisplayContext);
}

/**
 * Use to hydrate a layout with a loading state.
 *
  * Only necessary once per top-level checkout layout
 */
export function useCheckoutFormDisplayState(): CheckoutFormDisplay {
  const [isLoading, setLoading] = React.useState(false);

  return {
    isLoading,
    setLoading,
  };
}
